import { CurrencyConfig, PrinterPreset, FilamentItem, CalculationProfile } from './types';

export const CURRENCIES: CurrencyConfig[] = [
  { code: 'ARS', symbol: 'ARS $', label: 'Pesos Argentinos', defaultKwhPrice: 120 },
  { code: 'USD', symbol: 'USD US$', label: 'Dólares Estadounidenses', defaultKwhPrice: 0.16 },
  { code: 'EUR', symbol: 'EUR €', label: 'Euros', defaultKwhPrice: 0.22 },
];

export const PRINTER_PRESETS: PrinterPreset[] = [
  { id: 'bambu_p1s', name: 'Bambu Lab P1S / X1-Carbon', powerWatts: 350, lifespanHours: 4000, replacementCost: 120000 },
  { id: 'bambu_a1', name: 'Bambu Lab A1 / A1 Mini', powerWatts: 150, lifespanHours: 3500, replacementCost: 60000 },
  { id: 'ender_3_v3', name: 'Creality Ender 3 V3 / SE / KE', powerWatts: 220, lifespanHours: 2500, replacementCost: 45000 },
  { id: 'ender_3_pro', name: 'Creality Ender 3 / Pro / V2', powerWatts: 200, lifespanHours: 2000, replacementCost: 35000 },
  { id: 'artillery_genius', name: 'Artillery Genius / Sidewinder', powerWatts: 280, lifespanHours: 2500, replacementCost: 40000 },
  { id: 'creality_k1', name: 'Creality K1 / K1 Max', powerWatts: 350, lifespanHours: 3500, replacementCost: 95000 },
  { id: 'voron_24', name: 'Voron 2.4 / Trident', powerWatts: 420, lifespanHours: 5000, replacementCost: 140000 },
  { id: 'prusa_mk4', name: 'Prusa MK3S+ / MK4', powerWatts: 200, lifespanHours: 5000, replacementCost: 75000 },
  { id: 'custom', name: 'Personalizada...', powerWatts: 250, lifespanHours: 3000, replacementCost: 50000 },
];

export const SAVED_FILAMENTS: Omit<FilamentItem, 'id' | 'weightGrams'>[] = [
  { name: 'PLA+ - Negro (FILALAB)', material: 'PLA+', colorName: 'Negro', colorHex: '#1a1a1a', pricePerKg: 19500 },
  { name: 'PLA - Blanco (Grilon3)', material: 'PLA', colorName: 'Blanco', colorHex: '#f3f4f6', pricePerKg: 18000 },
  { name: 'PLA+ - Gris Espacial (GST3D)', material: 'PLA+', colorName: 'Gris', colorHex: '#6b7280', pricePerKg: 16500 },
  { name: 'PETG - Rojo Fuego (Printalot)', material: 'PETG', colorName: 'Rojo', colorHex: '#ef4444', pricePerKg: 22000 },
  { name: 'PETG - Cristal / Translúcido', material: 'PETG', colorName: 'Cristal', colorHex: '#cbd5e1', pricePerKg: 23500 },
  { name: 'ABS - Negro Industrial (Printalot)', material: 'ABS', colorName: 'Negro', colorHex: '#111827', pricePerKg: 21000 },
  { name: 'TPU 95A - Flexible Azul (Grilon3)', material: 'TPU', colorName: 'Azul', colorHex: '#3b82f6', pricePerKg: 28000 },
  { name: 'ASA - Grafito UV (Printalot)', material: 'ASA', colorName: 'Grafito', colorHex: '#374151', pricePerKg: 25000 },
  { name: 'Resina Estándar - Gris 405nm', material: 'Resina', colorName: 'Gris', colorHex: '#9ca3af', pricePerKg: 32000 },
];

export const MATERIAL_DENSITIES: Record<string, number> = {
  'PLA': 1.24,
  'PLA+': 1.24,
  'PETG': 1.27,
  'ABS': 1.04,
  'ASA': 1.07,
  'TPU': 1.21,
  'Nylon': 1.14,
  'Resina': 1.10,
};

export const DEFAULT_PROFILE: CalculationProfile = {
  id: 'default',
  name: 'Perfil Estándar PLA',
  currency: 'ARS',
  kwhPrice: 120,
  selectedPrinterId: 'bambu_p1s',
  powerWatts: 350,
  lifespanHours: 4000,
  replacementCost: 120000,
  errorMarginPercent: 8,
  filaments: [
    {
      id: 'fil-1',
      name: 'Filamento 1 — PLA+ - Negro (FILALAB)',
      material: 'PLA+',
      colorName: 'Negro',
      colorHex: '#1a1a1a',
      pricePerKg: 19500,
      weightGrams: 0,
    },
  ],
  printHours: 0,
  printMinutes: 0,
  suppliesCost: 0,
  designMode: 'fixed',
  designFixedCost: 0,
  designHourlyRate: 8500,
  designHours: 0,
  postProcessMode: 'fixed',
  postProcessFixedCost: 0,
  postProcessHourlyRate: 6000,
  postProcessHours: 0,
  profitMode: 'multiplier',
  profitMultiplier: 4, // Minorista (x4) por defecto
  profitPercentage: 100,
  externalCommissionPercent: 18,
};
